import { render, staticRenderFns } from "./rule-list.vue?vue&type=template&id=effdfcc0&scoped=true"
import script from "./rule-list.vue?vue&type=script&lang=js"
export * from "./rule-list.vue?vue&type=script&lang=js"
import style0 from "./rule-list.vue?vue&type=style&index=0&id=effdfcc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effdfcc0",
  null
  
)

export default component.exports